class HeaderComponent extends HTMLElement {
  constructor() {
    super();

    // select element
    this.headerElement = this;
    this.headerWrapper = document.querySelector('.shopify-section-group-header-group');
    this.announcementBar = document.querySelector('.section-announcement-bar');
    this.search = this.querySelector('[data-header-search]');
    this.searchToggle = this.querySelector('search-toggle');

    if (this.headerWrapper) {
      // scroll parameters
      this.currentScrollTop = 0;
      this.scrollOffset = 0;
      this.headerStart = 0;

      if (this.announcementBar) {
        const announcementBarHeight = this.announcementBar.offsetHeight;
        this.scrollOffset += announcementBarHeight;
        this.headerStart += announcementBarHeight;
      }

      if (this.headerElement) {
        this.scrollOffset += this.headerElement.offsetHeight;
      }

      // const headerHeight = this.headerStart + this.headerElement.offsetHeight;
      // console.log('headerHeight', announcementBarHeight, this.headerElement.offsetHeight);

      // set global css var for the header height
      // document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      // scroll event
      this.request = null; // Safe request animation frame
      this.timer = null; // Safe scroll timer

      window.addEventListener('scroll', debounce(() => {
        clearTimeout(this.timer);
        // A request animation frame is used to animate on max 60fps.
        if (!this.request) this.request = requestAnimationFrame(this.scrollAnimation.bind(this));
        this.timer = setTimeout(() => {
          // Stop animation, cancel request animation frame
          cancelAnimationFrame(this.request);
          this.request = null;
        }, 50);
      }, 10));
    }
  }

  scrollAnimation() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    // only animate if header is closed.
    if (!document.body.classList.contains('desktop-submenu-is-open')) {
      if (scrollTop + window.innerHeight > document.body.clientHeight) {
        this.hide();
      }
      else if (scrollTop > this.currentScrollTop && scrollTop > this.scrollOffset) {
        this.hide();
      }
      else if (scrollTop <= this.headerStart) {
        this.revealTop();
      }
      else if (scrollTop < this.currentScrollTop && scrollTop > this.headerStart) {
        this.reveal();
      }
    }

    this.currentScrollTop = scrollTop;

    // Recall request animation loop
    this.request = requestAnimationFrame(this.scrollAnimation.bind(this));
  }

  hide() {
    document.body.classList.add('header-hidden', 'header-sticky');
    this.closeSearch();
  }

  reveal() {
    document.body.classList.add('header-sticky');
    document.body.classList.remove('header-hidden');
  }

  revealTop() {
    document.body.classList.remove('header-hidden', 'header-sticky');
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) return false;
    if (this.search.classList.contains('header__search--is-active')) this.searchToggle.remove();
  }
}

if (!customElements.get('header-component')) {
  customElements.define('header-component', HeaderComponent);
}